var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSync(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.38045 8C4.89083 4.75092 8.18339 2.5 12 2.5C16.4465 2.5 20.1811 5.55546 21.2155 9.68234C21.3162 10.0841 21.7235 10.3282 22.1253 10.2275C22.5271 10.1268 22.7712 9.71945 22.6705 9.31766C21.4729 4.53939 17.1507 1 12 1C7.94757 1 4.40828 3.19117 2.5 6.45159V4.75C2.5 4.33579 2.16421 4 1.75 4C1.33579 4 1 4.33579 1 4.75V8.5C1 9.05228 1.44772 9.5 2 9.5H5.75C6.16421 9.5 6.5 9.16421 6.5 8.75C6.5 8.33579 6.16421 8 5.75 8H3.38045Z",
    fill: "#111111"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.78456 14.3177C2.68386 13.9159 2.27651 13.6718 1.87473 13.7725C1.47294 13.8732 1.22886 14.2806 1.32956 14.6823C2.52717 19.4606 6.84932 23 12 23C16.0524 23 19.5917 20.8089 21.5 17.5485V19.25C21.5 19.6642 21.8358 20 22.25 20C22.6642 20 23 19.6642 23 19.25V15.5C23 14.9477 22.5523 14.5 22 14.5H18.25C17.8358 14.5 17.5 14.8358 17.5 15.25C17.5 15.6642 17.8358 16 18.25 16H20.6196C19.1092 19.2491 15.8166 21.5 12 21.5C7.55358 21.5 3.8189 18.4445 2.78456 14.3177Z",
    fill: "#111111"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSync);
export default __webpack_public_path__ + "static/media/sync.1a3c513a.svg";
export { ForwardRef as ReactComponent };